var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[(_vm.showIcon)?_c('span',{staticClass:"glyphicon glyphicon-ok"}):_vm._e(),_vm._l((_vm.value),function(item){return _c('span',{key:item.Name},[_c('span',{staticClass:"circle marginal-left-m marginal-right-m",class:item.ColourClass,attrs:{"title":item.Name}}),_c('span',[_vm._v(_vm._s(item.Name))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }